// extracted by css-extract-rspack-plugin
export default {"alert":"Cpk5GSCNMcWsUwk8"};